import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useNotificationsStore } from "../../store/notificationsStore";
import { Text } from "../catalyst/text";
import { Button } from "../catalyst/button";
import { ClipboardIcon, PencilIcon } from "@heroicons/react/24/outline";
interface SeasonInviteNotificationProps {
  registrationCutoffDate: string;
  seasonName: string;
  seasonNumber: string;
  notification: any;
}

const SeasonInviteNotification: React.FC<SeasonInviteNotificationProps> = ({
  notification,
  registrationCutoffDate,
  seasonName,
  seasonNumber,
}) => {
  const navigate = useNavigate();
  const { getUserRegistrationForSeason, userRegistrationForSeason } =
    useNotificationsStore();

  const disableRegister = () => {
    if (
      userRegistrationForSeason &&
      (userRegistrationForSeason.role === "player" ||
        userRegistrationForSeason.role === "captain" ||
        userRegistrationForSeason.role === "playingTeamOwner")
    ) {
      return true;
    }
    return false;
  };

  const canPlayerEditRegistration = () => {
    if (
      userRegistrationForSeason &&
      (userRegistrationForSeason.role === "player" ||
        userRegistrationForSeason.role === "captain" ||
        userRegistrationForSeason.role === "playingTeamOwner") &&
      notification.season &&
      notification.season.allowPlayersToEditRegistration
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    getUserRegistrationForSeason(notification.season.id, notification.userName);
  }, [notification]);

  return (
    <div className="mb-6 bg-white dark:bg-gray-800 p-6 md:p-8 shadow-lg rounded-lg max-w-[800px] mx-auto">
      <h1 className="text-2xl font-bold mb-4 flex items-center justify-center text-center text-gray-900 dark:text-gray-100">
        {disableRegister() ? (
          <>
        🏌️ You're Registered for HPGL! ⛳
        <span className="ml-2">🏆</span>
          </>
        ) : (
          <>
        🏌️ Join the Golf League – Register Now! ⛳
        <span className="ml-2">🏆</span>
          </>
        )}
      </h1>
      <p className="mb-4 text-gray-700 dark:text-gray-300">
        {disableRegister() ? (
          <>
            Great news! You're all set for the Hyderabad Premiere Golf League (HPGL)
            <b> {seasonNumber}</b>. Get ready for an exciting season!
          </>
        ) : (
          <>
            Calling all golf enthusiasts! The Hyderabad Premiere Golf League (HPGL)
            is back for its <b>{seasonNumber}</b>
          </>
        )}
      </p>
      {!disableRegister() && (
        <>
          <p className="mb-6 text-gray-700 dark:text-gray-300">How to Register:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300">
            <li>
              Click the button below to secure your spot for <b>{seasonName}.</b>
            </li>
            <li>
              Registrations close on <b>{registrationCutoffDate}.</b>
            </li>
          </ul>
        </>
      )}
      <div className="flex justify-center items-center mt-4 gap-3">
        {!disableRegister() && (
          <Button
            className={`px-4 bg-blue-500 text-white rounded hover:bg-blue-700 w-[250px]`}
            disabled={disableRegister()}
            color="blue"
            onClick={() =>
              navigate("/registerForSeason/?id=" + notification.notificationId)
            }
          >
            <ClipboardIcon className="h-5 w-5 mr-2" />
            Register
          </Button>
        )}
        {canPlayerEditRegistration() && (
          <Button
            className={`px-4 bg-green-500 text-white rounded hover:bg-green-700 w-[250px]`}
            color="green"
            onClick={() =>
              navigate("/registerForSeason/?id=" + notification.notificationId)
            }
          >
            <PencilIcon className="h-5 w-5 mr-2" />
            Edit Registration
          </Button>
        )}
      </div>
      {disableRegister() && (
        <div className="flex justify-center items-center mt-4 gap-3">
          <Text>You are already registered for this season. All the best!</Text>
        </div>
      )}
    </div>
  );
};

export default SeasonInviteNotification;
